import { AppleIcon, Smartphone, Store } from "lucide-react"
import { Link } from "react-router-dom"
import { QRCodeCanvas } from "qrcode.react";
import { siteUrl } from "../config/site";

export default function QrCodeSection() {

    const imagePath = process.env.REACT_APP_IMAGE_PATH;

    return (
        <section className="relative w-full sm:py-24 !mb-1 !mt-8 py-14 overflow-hidden">

            {/* Formes décoratives */}
            <div className="absolute top-20 left-10 w-64 h-64 rounded-full bg-[#5bcfc5]/10 blur-3xl" />
            <div className="absolute bottom-10 right-10 w-80 h-80 rounded-full bg-[#5bcfc5]/10 blur-3xl" />
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full bg-white/5 blur-3xl" />

            <div className="container relative px-4 md:px-6 mx-auto z-10">
                <div className="max-w-5xl mx-auto bg-gradient-to-br to-[#5bcfc5]/5 inset-0" style={{ backdropFilter: "blur(100px)" }}>
                    {/* Carte principale avec effet glassmorphism */}
                    <div className="backdrop-blur-xl bg-white/10 border border-white/20 rounded-3xl shadow-xl overflow-hidden">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            {/* Contenu textuel */}
                            <div className="p-8 md:p-12 flex flex-col justify-center space-y-6">
                                {/* <div className="inline-block rounded-full bg-[#5bcfc5]/20 backdrop-blur-sm px-4 py-1 text-sm border border-[#5bcfc5]/30 text-[#5bcfc5] font-medium w-fit">
                                    Téléchargement simplifié
                                </div> */}

                                <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-gray-800">
                                    Votre prochain événement commence ici !
                                </h2>

                                <p className="text-gray-600 md:text-lg max-w-md">
                                    Scannez ce QR code et installez l'application en quelques secondes.
                                    Accédez à une billetterie mobile rapide, sécurisée et pensée pour réserver sans stress.
                                </p>

                                <div className="flex flex-col sm:flex-row gap-4 pt-2">
                                    <Link to="https://apps.apple.com/ci/app/events-billetterie/id6738791983" target="_blank" rel="noopener noreferrer"
                                        className="group px-3 py-2 rounded-lg bg-white/80 hover:bg-white text-gray-800 border border-gray-200 backdrop-blur-sm flex items-center gap-2 transition-all duration-300 shadow-sm hover:shadow"
                                        size="lg"
                                    >
                                        <AppleIcon className="h-4 w-4 text-black" />
                                        <div className="flex flex-col items-start text-left">
                                            <span className="text-xs">Disponible sur</span>
                                            <span className="font-semibold">App Store</span>
                                        </div>
                                    </Link>

                                    <Link to="https://play.google.com/store/apps/details?id=com.event.event_app" target="_blank" rel="noopener noreferrer"
                                        className="group px-3 py-2 rounded-lg bg-white/80 hover:bg-white text-gray-800 border border-gray-200 backdrop-blur-sm flex items-center gap-2 transition-all duration-300 shadow-sm hover:shadow"
                                        size="lg"
                                    >
                                        <Store className="h-4 w-4 text-[#5bcfc5]" />
                                        <div className="flex flex-col items-start text-left">
                                            <span className="text-xs">Télécharger sur</span>
                                            <span className="font-semibold">Google Play</span>
                                        </div>
                                    </Link>
                                </div>

                                <div className="flex items-center gap-2 text-gray-500 text-sm pt-4">
                                    <Smartphone className="h-4 w-4" />
                                    <span>iOS & Android - Installation immédiate</span>
                                </div>
                            </div>

                            {/* QR Code avec effet glassmorphism */}
                            <div className="relative flex items-center justify-center p-8 md:p-0">
                                <div className="relative group">
                                    {/* Cercle décoratif */}
                                    <div className="absolute -inset-4 rounded-full bg-gradient-to-r from-[#5bcfc5]/30 to-white/30 blur-lg opacity-70 group-hover:opacity-100 transition duration-500 group-hover:scale-105"></div>

                                    {/* Carte QR avec effet de verre */}
                                    <div className="relative flex flex-col items-center backdrop-blur-xl bg-white/60 p-8 rounded-2xl shadow-lg border border-white/50 transition-all duration-300 group-hover:shadow-xl group-hover:bg-white/70">
                                        {/* <div className="flex items-center gap-2 mb-4">
                                            <QrCode className="h-6 w-6 text-[#5bcfc5]" />
                                            <span className="font-medium text-gray-700">QR Code de téléchargement</span>
                                        </div> */}

                                        <div className="h-64 w-64 bg-white/80 backdrop-blur-sm rounded-xl overflow-hidden flex items-center justify-center relative p-4 border border-[#5bcfc5]/20 shadow-inner">
                                            <div className="absolute inset-0 bg-gradient-to-tr from-[#5bcfc5]/5 to-transparent"></div>
                                            {/* <img
                                                src={`${imagePath}images/Events-app-scanMe.png`}
                                                alt="QR Code pour télécharger l'application Events"
                                                width={250}
                                                height={250}
                                                className="relative z-10 transition-transform duration-300 group-hover:scale-105"
                                            /> */}
                                            <QRCodeCanvas
                                                className="relative z-10 transition-transform duration-300 group-hover:scale-105"
                                                value={siteUrl('/go')}
                                                size={240}
                                                bgColor="#ffffff"
                                                fgColor="#000000"
                                                level="H"
                                                includeMargin={true}
                                                imageSettings={{
                                                    src: `${imagePath}images/logo-events-QRoption.png`,
                                                    height: 40,
                                                    width: 40,
                                                    excavate: true,
                                                }}
                                            />

                                            {/* Effet de brillance */}
                                            <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700 transform rotate-12"></div>
                                        </div>

                                        <div className="mt-6 text-center text-sm text-gray-600 max-w-[250px]">
                                            <p>Scanne-moi et télécharge maintenant.</p>
                                            {/* <div className="mt-2 flex items-center justify-center">
                                                <span className="inline-block px-3 py-1 rounded-full bg-[#5bcfc5]/10 text-[#5bcfc5] text-xs font-medium">
                                                    Accès instantané à vos billets
                                                </span>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
